import BulkModifyShelter from "../../../views/BulkModifyShelter.js";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const BulkModifyShelterRoutes = [
  {
    menuName: MenuNames.DRIVER_SHELTER,
    path: "/bulk-modify-shelter",
    component: BulkModifyShelter,
    exact: true,
  },
];

export default BulkModifyShelterRoutes;
